/*
 * @Author:  HHQ
 * @Date: 2022-05-26 10:06:14
 * @LastEditTime: 2022-06-07 17:30:25
 * @LastEditors: HHQ
 * @Description: ComponentS简介
 * 改动内容：
 */
import babelpolyfill from 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import '@/assets/styles/element-variables.scss';
import VueRouter from 'vue-router';
import { _http } from './js/utils/http';
import _comm from './js/utils/common';
import _config from './js/utils/config';
// import _config from '../config/index';
import storage from '@/js/utils/storage';
// 高德地图
import VueAMap from 'vue-amap';
// 富文本编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import quilleditor from './components/quilleditor';

// import store from './vuex/store'
// import Vuex from 'vuex'
import routes from './router/routes';

import './assets/styles/base.scss';
// import './js/plugins/elDialogDrag.js'

/*********************页面tab标签插件*********************/
import RouterTab from 'vue-router-tab';
import 'vue-router-tab/dist/lib/vue-router-tab.css';
import customPagination from './components/customPagination';
Vue.use(customPagination);
Vue.use(RouterTab);
/*********************页面tab标签插件*********************/
Vue.use(VueRouter);
Vue.use(ElementUI);

/*********************高德地图初始化*********************/
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    // key: _config.gaodeMapKey,
    key: '2faaca36dc73b043479bb59b21e697fc',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});

// Vue.use(VueRouter)
// Vue.use(Vuex)
/*********************给vue原型添加参数*********************/
Vue.prototype._http = _http; //api调用方式
Vue.prototype._comm = _comm; //公共方法使用
Vue.prototype._storage = storage;
// Vue.prototype._config = _config; //配置文件参数
// 暂时解决图片上传地址问题
// Vue.prototype._config = location.hostname == 'localhost' ? _config.dev.proxyTable['/api'].target : location.origin + '/api'; //配置文件参数

// Vue.prototype._config = _config.dev.proxyTable['/api'].target;
Vue.prototype._config = _config.api;
/*********************定义组件*********************/
Vue.component('quill-editor', quilleditor);

/*********************测试数据api*********************/
/*import Mock from './mock'
Mock.bootstrap();
import { testApi } from './api/api';
Vue.prototype._http = testApi;*/
/*********************测试数据api*********************/

// console.log('routers-------->', routes);
const router = new VueRouter({
    routes,
    mode: 'hash',
    strict: process.env.NODE_ENV !== 'production',
    scrollBehavior(to, from, savedPosition) {}
});

router.beforeEach((to, from, next) => {
    console.log('to----->', to);
    if (storage.LStorage.get('_tAdmin') && to.path != '/login') {
        if (from.path == '/login') {
            next();
        } else {
            let menuList = storage.LStorage.get('_menu');
            menuList.push({
                moduleUrl: '/404'
            });
            console.log(menuList);
            // 循环storage.LStorage.get('_menu'),与children，查找to.path是否有moduleUrl相同
            // to.path在menuList及其子集合children的moduleUrl是否能够查找到
            let isFind = false;
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].moduleUrl === to.path) {
                    isFind = true;
                    break;
                }
                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (menuList[i].children[j].moduleUrl === to.path) {
                            isFind = true;
                            break;
                        }
                    }
                }
            }
            if (!isFind) {
                next({
                    path: '/404'
                });
            } else {
                next();
            }
        }
    } else {
        if (to.path == '/login') {
            next();
        } else {
            router.push({
                path: '/login',
                query: {}
            });
        }
    }
});

new Vue({
    router,
    // store,
    render: (h) => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js